import { Collapse, Grid, InputBase } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import LinkButton from 'components/common/buttons/LinkButton'
import PrimaryButton from 'components/common/buttons/PrimaryButton'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { trackEvent } from 'utils/analyticsUtils'
import TrackingConditionOption from './TrackingConditionOption'
import useGaFlags from 'hooks/useGaFlags'

const useStyles = makeStyles(theme => ({
  notesInput: {
    fontSize: 14,
    fontWeight: 500,
    border: '1px solid var(--border-color-24)',
    borderRadius: 12,
    width: '100%',
    padding: 16
  }
}))

const EditTrackingTagging = ({
  conditionOptions,
  setConditionEnabled,
  values,
  setConditionSelections,
  untrackedTeeth,
  isNoteEnabled,
  submit,
  isLoading,
  isSubmitDisabled,
  isHiUser,
  irrelevantConditionOptions
}) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { AIForHI } = useGaFlags()

  const [shouldShowIrrelevantConditions, setShouldShowIrrelevantConditions] = useState(false)

  const shouldRenderIrrelevantConditions = irrelevantConditionOptions.length > 0 && AIForHI

  const handleToggleIrrelevantConditionsClicked = useCallback(() => {
    trackEvent('HI - Toggle irrelevant conditions', {
      isOpen: !shouldShowIrrelevantConditions
    })
    setShouldShowIrrelevantConditions(!shouldShowIrrelevantConditions)
  }, [shouldShowIrrelevantConditions])

  return (
    <>
      <Grid item>
        <Grid container direction="column">
          {conditionOptions.map(condition => (
            <Grid item key={`tracking-condition-option-${condition.id}`}>
              <TrackingConditionOption
                conditionId={condition.id}
                onToggle={setConditionEnabled}
                checked={!!values.conditions[condition.id]}
                selections={values.conditions[condition.id]?.selections}
                onSelectionsChanged={setConditionSelections}
                untrackedTeeth={untrackedTeeth}
                disableCloseOnSelect
              />
            </Grid>
          ))}
          {shouldRenderIrrelevantConditions && (
            <>
              <Collapse in={shouldShowIrrelevantConditions}>
                {irrelevantConditionOptions.map(condition => (
                  <Grid item key={`tracking-condition-option-${condition.id}`}>
                    <TrackingConditionOption
                      conditionId={condition.id}
                      onToggle={setConditionEnabled}
                      checked={!!values.conditions[condition.id]}
                      selections={values.conditions[condition.id]?.selections}
                      onSelectionsChanged={setConditionSelections}
                      untrackedTeeth={untrackedTeeth}
                      disableCloseOnSelect
                    />
                  </Grid>
                ))}
              </Collapse>
              <LinkButton
                fontSize={14}
                label={shouldShowIrrelevantConditions ? t('general.less') : t('general.more')}
                onClick={handleToggleIrrelevantConditionsClicked}
              />
            </>
          )}
        </Grid>
      </Grid>
      {isNoteEnabled && (
        <Grid item>
          <InputBase
            value={values.notes}
            onChange={e => values.setNotes(e.target.value)}
            multiline
            rows={4}
            className={classes.notesInput}
            placeholder={t('dialogs.scanSummary.treatmentTracking.notesPlaceholder')}
          />
        </Grid>
      )}
      <Grid item>
        <Grid container justifyContent="space-between">
          <PrimaryButton
            label={t('general.submit')}
            onClick={submit}
            small
            isLoading={isLoading}
            disabled={isSubmitDisabled}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default EditTrackingTagging
